import { Controller } from "@hotwired/stimulus"

// Drives the "Email the hospital" widget embedded in calling drawers.
// - submits the (multipart) form via fetch so attachments upload and the status
//   turbo-stream renders without navigating, with a busy state on the button
// - clears the compose fields after a successful send (server signals via the
//   status partial's data-clear-form marker)
export default class extends Controller {
  static targets = ["form", "subject", "body", "fileInput", "status", "submitButton"]

  async submit(event) {
    event.preventDefault()

    const form = this.formTarget
    const formData = new FormData(form)

    this.setBusy(true)
    try {
      const response = await fetch(form.action, {
        method: "POST",
        body: formData,
        headers: {
          "Accept": "text/vnd.turbo-stream.html",
          "X-CSRF-Token": this.csrfToken()
        }
      })
      const html = await response.text()
      if (window.Turbo) {
        window.Turbo.renderStreamMessage(html)
      }
      this.maybeClearForm()
    } catch (error) {
      if (this.hasStatusTarget) {
        this.statusTarget.innerHTML = `<div class="text-alert-red-600 text-sm">Something went wrong sending the email. Please try again.</div>`
      }
    } finally {
      this.setBusy(false)
    }
  }

  // The status partial includes a [data-clear-form] marker on success; when present we reset the
  // compose fields (but keep the chosen recipient so a follow-up email is quick to send).
  maybeClearForm() {
    if (!this.hasStatusTarget) return
    if (!this.statusTarget.querySelector("[data-clear-form]")) return

    if (this.hasSubjectTarget) this.subjectTarget.value = ""
    if (this.hasBodyTarget) this.bodyTarget.value = ""
    if (this.hasFileInputTarget) this.fileInputTarget.value = ""
  }

  setBusy(busy) {
    if (!this.hasSubmitButtonTarget) return
    this.submitButtonTarget.disabled = busy
    if (busy) {
      this.submitButtonTarget.dataset.label = this.submitButtonTarget.textContent
      this.submitButtonTarget.textContent = "Sending..."
    } else if (this.submitButtonTarget.dataset.label) {
      this.submitButtonTarget.textContent = this.submitButtonTarget.dataset.label
    }
  }

  csrfToken() {
    const meta = document.querySelector('meta[name="csrf-token"]')
    return meta ? meta.content : ""
  }
}
